import { render, staticRenderFns } from "./IconStop.vue?vue&type=template&id=6364157e"
import script from "./IconStop.vue?vue&type=script&lang=js"
export * from "./IconStop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports